import { SDUIProductTileImpressionProvider } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { SDUIComponentInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { trackBrandTileHelper } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/trackBrandTileHelper";
import { SDUITileRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/SDUITileRenderer";
import React from "react";

export const SDUITileWrapperComponentRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  if (!component.tile_wrapper_component?.tile) {
    return null;
  }

  const tileElement = component.tile_wrapper_component.tile;

  return (
    <SDUIProductTileImpressionProvider
      loggingData={loggingData}
      trackAsBrandClickType={trackBrandTileHelper(tileElement)}
    >
      <SDUITileRenderer tileElement={tileElement} loggingData={loggingData} />
    </SDUIProductTileImpressionProvider>
  );
};
